import { createWebHistory, createRouter } from "vue-router";
import FormSection from "@/components/FormSection.vue";
import NotFoundSection from "@/components/NotFoundSection.vue";
import CredencialSection from "@/components/CredencialSection.vue";
import LoginSection from "@/components/LoginSection.vue";

const routes = [
  {
    path: "/",
    component: LoginSection,
  },
  {
    path: "/formulario/dni/:dni",
    component: FormSection,
  },
  {
    path: "/formulario/hash/:hash",
    component: FormSection,
  },
  {
    path: "/credencial/:hash",
    component: CredencialSection,
  },
  {
    path: "/:catchAll(.*)",
    component: NotFoundSection,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: routes,
  scrollBehavior() {
    return { top: 0 }
  }
});

export default router;